/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestdecline1Inputs */

const en_requestdecline1 = /** @type {(inputs: Requestdecline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

const de_requestdecline1 = /** @type {(inputs: Requestdecline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

/**
* | output |
* | --- |
* | "Decline" |
*
* @param {Requestdecline1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestdecline1 = /** @type {((inputs?: Requestdecline1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestdecline1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestdecline1(inputs)
	return de_requestdecline1(inputs)
});
export { requestdecline1 as "requestDecline" }